import { useNavigate } from 'react-router-dom';
import { Modal, ModalHeader } from '@/components/ui';
import { CustomerProfile } from '@/components/CustomerProfile';

type HoldingsCustomer = { id: string; name: string; phone?: string };

/**
 * 顧客資產明細視窗(儲值金 + 堂票),含「前往儲值 / 核銷」快捷。
 * 顧客主頁、今日看板共用。
 */
export function CustomerHoldingsModal({
  customer,
  onClose,
}: {
  customer: HoldingsCustomer | null;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  return (
    <Modal open={!!customer} onClose={onClose} width={680}>
      <ModalHeader
        title={`${customer?.name ?? ''} · 顧客 360`}
        sub={`${customer?.phone ?? ''} · 消費 / 到訪 / 儲值 / 堂票 一頁看完`}
        onClose={onClose}
      />
      <div style={{ padding: 18, maxHeight: '64vh', overflowY: 'auto' }}>
        {customer && <CustomerProfile customerId={customer.id} />}
      </div>
      <div style={{ display: 'flex', gap: 8, padding: 16, borderTop: '1px solid var(--line)' }}>
        <button className="btn btn-ghost" style={{ flex: 1 }} onClick={onClose}>
          關閉
        </button>
        <button
          className="btn btn-ghost"
          style={{ flex: 1.3 }}
          disabled={!customer}
          onClick={() => {
            if (!customer) return;
            navigate(`/billing?customerId=${customer.id}&name=${encodeURIComponent(customer.name)}`);
            onClose();
          }}
        >
          儲值 / 核銷
        </button>
        <button
          className="btn btn-primary"
          style={{ flex: 1.3 }}
          disabled={!customer}
          onClick={() => {
            if (!customer) return;
            navigate(`/checkout?customerId=${customer.id}&name=${encodeURIComponent(customer.name)}`);
            onClose();
          }}
        >
          一鍵結帳
        </button>
      </div>
    </Modal>
  );
}
